import React from 'react';
import { CLEAR_QUERY_PARAMS_URL } from '../../../../Feature/hedin-filters/actions/types';

const FilterResetButton = (props) => {
  const { filterType } = props;

  const onClearFilter = () => {
    props.filterActions(CLEAR_QUERY_PARAMS_URL, null, { filterType });
    props.onClear();
  };

  return (
    <button className="button button--chips" onClick={() => onClearFilter()}>
      <span>Fjerne filtre</span>
    </button>
  );
};
export default FilterResetButton;
